import { render, staticRenderFns } from "./Operations.vue?vue&type=template&id=1970de49"
import script from "./Operations.vue?vue&type=script&lang=js"
export * from "./Operations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports